"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const Store_1 = require("../Store");
let ProductBox = class ProductBox extends React.Component {
    onClick() {
        Store_1.default.trackPageView(this.props.product);
        Store_1.default.SelectedProduct = this.props.product;
        document.title = this.props.product.name + " | Hartwall";
        Store_1.default.SelectedProduct.loadDetails();
        Store_1.default.loadProducts();
        $([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, Store_1.default._scrollspeed);
    }
    render() {
        const backgroundColor = this.props.product.imageBackgroundColor ? { backgroundColor: this.props.product.imageBackgroundColor } : {};
        const columnSize = `col-md-${this.props.columnSize_medium || 3}`;
        return (React.createElement(react_router_dom_1.Link, { to: this.props.product.url, onClick: this.onClick, className: "o-product-container " + columnSize + " col-sm-4 col-xs-6" },
            React.createElement("div", { className: "bottle bottlesize-" + this.props.product.bottlesize, style: backgroundColor },
                React.createElement("div", { className: "product-image", style: { backgroundImage: "url(" + this.props.product.imageUrl + "?height=600" + ")" } })),
            React.createElement("span", null, this.props.product.name),
            React.createElement("span", null, this.props.product.description)));
    }
};
__decorate([
    mobx_1.action.bound
], ProductBox.prototype, "onClick", null);
ProductBox = __decorate([
    mobx_react_1.observer
], ProductBox);
exports.default = ProductBox;
